export default __webpack_public_path__ + "media/images/Masto-K1-DiaDeLosMuertos-845a87693b9ad3117c5011226c8565dd.png";